<div class="vertical-nav" [ngClass]="{ 'iframe-border': isIframe }">
	@if (isIframe) {
		<iframe-banner
			(bannerClosed)="onBannerClosed()">
		</iframe-banner>
	}
	<dashboard [ngClass]="{ 'has-banner': isBannerOpen }">
		<router-outlet></router-outlet>
	</dashboard>
</div>

<ngx-go-toast></ngx-go-toast>

@if (sessionEnded) {
	<ngx-user-session-expiration>
	</ngx-user-session-expiration>
}
